import { gql } from '@apollo/client'

export const BUSINESS_ACTIVITIES_TREE_UPDATE_MUTATION = gql`
  mutation BUSINESS_ACTIVITIES_TREE_UPDATE_MUTATION($businessActivities: [BusinessActivitiesTreeUpdateInput]!) {
    businessActivitiesTreeUpdate(businessActivities: $businessActivities) {
      ok
    }
  }
`

export const BUSINESS_ACTIVITY_DELETE_MUTATION = gql`
  mutation BUSINESS_ACTIVITIES_DELETE_MUTATION($id: ID!) {
    businessActivityDelete(id: $id) {
      ok
    }
  }
`

export const BUSINESS_ACTIVITY_UPDATE_MUTATION = gql`
  mutation BUSINESS_ACTIVITY_UPDATE_MUTATION($id: ID!, $businessActivity: BusinessActivityUpdateInput!) {
    businessActivityUpdate(id: $id, businessActivity: $businessActivity) {
      ok
    }
  }
`

export const BUSINESS_ACTIVITY_CREATE_MUTATION = gql`
  mutation BUSINESS_ACTIVITY_CREATE_MUTATION($businessActivity: BusinessActivityCreateInput!) {
    businessActivityCreate(businessActivity: $businessActivity) {
      ok
    }
  }
`
